var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { ChoiceOptionState } from '../../../../../classes/learnware/LearnwareEnums';
import { Actor_ } from '../../../../../components/actor/Actor_';
import { QuestionAssociate } from '../../../../../questiontype/Associate/QuestionAssociate';
import { AbfragerAssociateAssociations } from '../../Associate/AbfragerAssociateAssociations';
import { Aspect_ } from '../../../../../components/actor/Aspect_';
import { AvailablePopover } from '../../../../../components/other/AvailablePopover';
let AbfragerMultipleChoiceOptionGridCell = class AbfragerMultipleChoiceOptionGridCell extends React.PureComponent {
    get isEditing() {
        return this.props.option.context.app.appInfo.isUserCurrentlyEditing;
    }
    get optionState() {
        return this.props.option.optionUI.choiceOptionUIState;
    }
    get optionBorder() {
        if ([ChoiceOptionState.ShouldHaveBeenSelected, ChoiceOptionState.CorrectPending, ChoiceOptionState.CorrectDone].includes(this.optionState)) {
            return '1px solid rgba(165, 201, 86, 0.95)';
        }
        if (this.optionState === ChoiceOptionState.Wrong) {
            return '1px solid #d9534f';
        }
        if (this.props.option.isPreselecting) {
            return '1px solid #bbb';
        }
        return '1px solid #ccc';
    }
    get optionBackground() {
        if ([ChoiceOptionState.ShouldHaveBeenSelected, ChoiceOptionState.CorrectPending, ChoiceOptionState.CorrectDone].includes(this.optionState)) {
            return '#cdea8e';
        }
        if (this.optionState === ChoiceOptionState.Wrong) {
            return 'linear-gradient(#ffffff, #f1f1f1)';
            // return 'linear-gradient(to bottom, #fec1c1 0%, #f48888 200%)';
        }
        if (this.props.option.isPreselecting) {
            return 'linear-gradient(#f6f6f6,#e0e0e0)';
        }
        return 'linear-gradient(#ffffff, #f1f1f1)';
    }
    get optionBoxShadow() {
        if ([ChoiceOptionState.ShouldHaveBeenSelected, ChoiceOptionState.CorrectPending, ChoiceOptionState.CorrectDone].includes(this.optionState)) {
            return '1px 1px 2px rgba(100, 100, 100, 0.5)';
        }
        return undefined;
    }
    get optionTextShadow() {
        if ([ChoiceOptionState.ShouldHaveBeenSelected, ChoiceOptionState.CorrectPending, ChoiceOptionState.CorrectDone].includes(this.optionState)) {
            return '0 1px 0 #FFF';
        }
        return undefined;
    }
    render() {
        const { option, children } = this.props;
        const question = option.question;
        const comp = (React.createElement(Actor_, { actor: option, structureTemplate: React.createElement("div", { "data-aspect": "inner", style: {
                    borderRadius: 13,
                    color: '#222',
                    padding: 5,
                    fontWeight: 500,
                    flex: '1 1 auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: this.optionBorder,
                    background: this.optionBackground,
                    boxShadow: this.optionBoxShadow,
                    textShadow: this.optionTextShadow
                } }, question instanceof QuestionAssociate && (React.createElement(AbfragerAssociateAssociations, { option: option }))) }));
        /*
        if (question.context.app.appInfo.isUserCurrentlyEditing) {
          comp = (
            <>
              <CheckableInEditMode option={option} />
              {comp}
            </>
          );
        }
    */
        return this.wrapCommentPopover(comp);
    }
    // todo: Comment placement based on indexInLayout
    wrapCommentPopover(comp) {
        const option = this.props.option;
        return (React.createElement(AvailablePopover, { placement: "right", content: option.commentAspectToShow && React.createElement(Aspect_, { aspect: option.commentAspectToShow }), visible: !!option.commentAspectToShow }, comp));
    }
};
AbfragerMultipleChoiceOptionGridCell = __decorate([
    observer
], AbfragerMultipleChoiceOptionGridCell);
export { AbfragerMultipleChoiceOptionGridCell };
